import React, { Component } from "react";
import "./QuizPage.scss";
import homeIcon from "../../../assets/images/home_icon.png";
import { NavLink } from "react-router-dom";
import $ from "jquery";
import {
  getFastQuizQuestions,
  saveReportScoreDetails,
  postTestScore,
} from "../../../actions";
import { connect } from "react-redux";
import LoaderComponent from "../../LoaderComponent";
import ImageLoader from "../../ImageLoader";
import { toArray, filter, find, concat, sampleSize, orderBy } from "lodash";
import MCHTypeQuestion from "./MCHTypeQuestion";
import MTRTypeQuestion from "./MTRTypeQuestion";
import MATTypeQuestion from "./MATTypeQuestion";
import PIOTypeQuestion from "./PIOTypeQuestion";
import MMGTypeQuestion from "./MMGTypeQuestion";
import MIXTypeQuestion from "./MIXTypeQuestion";
import global from "../../../global";

const quizSource = {
  E: "EASY",
  M: "MED",
  H: "HARD",
  A: "ALL",
};

//=============================================================================
// Class QuizPage
//=============================================================================
class QuizPage extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      currentQuestionId: 1,
      totalQuestions: 0,
      currentQuestion: null,
      attendedQuizQuestions: [],
      currentSecondCount: 0,
      perQuestionPoint: 10,
      isImageLoading: true,
      isTest: false,
      connectedMATOptionsCount: 0,
      totalMATOptionsCount: 0,
      quizQuestion: "",
      isPuzzleSolvingStarted: false,
    };
  }

  //---------------------------------------------------------------------------
  componentDidMount() {
    const { cookies } = this.props;
    if (
      this.props.history.location.state &&
      this.props.history.location.state.showQuiz === "1"
    ) 
    {
      var intervalId = setInterval(this.timer, 1000);
      this.setState({ intervalId: intervalId });
      const existingCookie = cookies.get("app_settings");
      let diff = "A";
      let qlimit = "0";

      if (existingCookie) {
        if (existingCookie.quiz_settings.diff) {
          diff = existingCookie.quiz_settings.diff;
          qlimit = existingCookie.quiz_settings.questions;
        }
      }
      if (this.props.history.location.state.isTest === "1") {
        diff = "A";
        qlimit = "0";
        this.setState({
          isTest: true,
        });
      }
      let questionsType =
        this.props.history.location.state.isTest === "1" ? "test" : "quiz";
      // FLAG-DEBUG-QUESTIONTYPE
      // console.log("RESTGET Params: " + params);
      let debugForceQType =
        global.config.debugQuestionType === "" ? "" : "&qtype=" + global.config.debugQuestionType;
      
      this.props
        .getFastQuizQuestions(
          "?qsid=" +
            global.config.QSID +
            "&diff=" +
            diff +
            "&qlimit=" +
            qlimit +
            "&type=" +
            questionsType +
            debugForceQType
        )
        .then((res) => {
          this.setState(
            {
              totalQuestions: toArray(this.props.fastQuizQuestions).length,
            },
            () => {
              this.setCurrentQuestion();
            }
          );
        })
        .catch((err) => {
          console.log(err);
        });
      this.props.history.replace(this.props.location.pathname, {});
    } else {
      this.props.history.push("/");
    }
    window.addEventListener("resize", this.resetHeaderPosition);
  }

  //---------------------------------------------------------------------------
  timer = () => {
    this.setState({ currentSecondCount: this.state.currentSecondCount + 1 });
  };

  //---------------------------------------------------------------------------
  secondsToHms = (d, isFormatted) => {
    d = Number(d);
    // var h = ("0" + Math.floor(d / 3600)).slice(-2);
    var m = ("0" + Math.floor((d % 3600) / 60)).slice(-2);
    var s = ("0" + Math.floor((d % 3600) % 60)).slice(-2);
    if (isFormatted === 1) {
      return parseInt(m, 10) + " Minutes, " + parseInt(s, 10) + " Seconds";
    } else {
      return m + ":" + s;
    }
  };

  //---------------------------------------------------------------------------
  componentWillUnmount() {
    clearInterval(this.state.intervalId);
    window.removeEventListener("resize", this.resetHeaderPosition);
  }

  //---------------------------------------------------------------------------
  resetHeaderPosition = () => {
    if (document.getElementById("question_header") !== null) {
      let headerHeight = document.getElementById("question_header")
        .offsetHeight;

      if (this.state.currentQuestion.QTypeShort === "MIX") {
        $(".question-data-container").css("padding-top", headerHeight + "px");
        $(".question-data-container").css("padding-bottom", "0px");
        if (!this.state.isPuzzleSolvingStarted) {
          let bottomLettersContainerHeight =
            parseInt($(".option-letters-container").height()) +
            parseInt($(".option-letters-container").css("padding-bottom"));
          $(".mix-data-container").css(
            "height",
            "calc( 100vh - " +
              (headerHeight + bottomLettersContainerHeight) +
              "px )"
          );
        }
      } else {
        $(".question-data-container").css(
          "padding-top",
          headerHeight + 20 + "px"
        );
      }
    }
  };

  //---------------------------------------------------------------------------
  setCurrentQuestion = () => {
    this.setState(
      {
        currentQuestion: this.props.fastQuizQuestions[
          parseInt(this.state.currentQuestionId) - 1
        ],
        isImageLoading: true,
        quizQuestion: "",
        isPuzzleSolvingStarted: false,
      },

      () => {
        if (this.state.currentQuestion.QTypeShort !== "MIX") {
          this.resetHeaderPosition();
          $(".question-data-container").animate({ scrollTop: 0 }, "fast");
          this.setState({
            isLoading: false,
          });
        }
      }
    );
  };

  //---------------------------------------------------------------------------
  addAttendedQuestion = (questionDetails) => {
    let { attendedQuizQuestions } = this.state;
    attendedQuizQuestions.push(questionDetails);
    this.setState(
      {
        attendedQuizQuestions,
      },
      () => {
        this.getNextQuestion();
      }
    );
  };

  //---------------------------------------------------------------------------
  getNextQuestion = () => {
    if (this.state.currentQuestionId < this.state.totalQuestions) {
      this.setState(
        (prevState) => ({
          currentQuestionId: parseInt(prevState.currentQuestionId) + 1,
        }),
        () => {
          this.setCurrentQuestion();
        }
      );
    } else {
      const { cookies } = this.props;
      const existingCookie = cookies.get("app_settings");
      let incorrectQuestions = [];
      let extraPoints = 0,
        correctPoints = 0,
        totalPoints = 0,
        scorePercentage = 0,
        mmgDeductionPoint = 0;
      this.state.attendedQuizQuestions.forEach((element) => {
        if (element.QTypeShort === "MAT") {
          if (element.deductionPercentage !== 0) {
            let questionData = {
              number: element.number,
              question: element.questionText,
              questionGraphic: element.questionGraphicUrl,
              QTypeShort: element.QTypeShort,
            };

            questionData.answers = filter(
              //---------------------------------------------------------------
              element.answers.map((ans) => {
                return [
                  find(element.matLeftOptionsArray, { matchId: ans.id1 })
                    .matchOptionText,
                  find(element.matRightOptionsArray, { matchId: ans.id2 })
                    .matchOptionText,
                  find(element.matRightOptionsArray, { matchId: ans.id2 })
                    .answerType,
                ];
              })
            );
            questionData.expectedAnswersCount = element.expectedAnswersCount;
            questionData.correctAnswersCount = element.correctAnswersCount;
            questionData.deductionPercentage = element.deductionPercentage
              ? element.deductionPercentage
              : 0;
            questionData.answerSummary =
              element.expectedAnswersCount -
              element.correctAnswersCount +
              " of " +
              element.expectedAnswersCount +
              " wrong";
            incorrectQuestions.push(questionData);
          }
        } else if (element.QTypeShort === "PIO") {
          if (element.deductionPercentage !== 0) {
            let questionData = {
              number: element.number,
              question: element.questionText,
              questionGraphic: element.questionGraphicUrl,
              QTypeShort: element.QTypeShort,
              answers: element.answers,
              isCorrect: element.isCorrect,
              correctAnswersCount: element.correctAnswersCount,
            };

            questionData.deductionPercentage = element.deductionPercentage
              ? element.deductionPercentage
              : 0;

            incorrectQuestions.push(questionData);
          }
        } else if (element.QTypeShort === "MIX") {
          if (element.isCorrect !== 1) {
            let questionData = {
              number: element.number,
              question: element.questionText,
              questionGraphic: element.questionGraphicUrl,
              QTypeShort: element.QTypeShort,
              answers: element.answers,
              isCorrect: element.isCorrect,
              correctAnswersCount: element.correctAnswersCount,
              questionFormatter: element.questionFormatter,
            };

            questionData.deductionPercentage = element.deductionPercentage
              ? element.deductionPercentage
              : 0;

            incorrectQuestions.push(questionData);
          }
        } else if (element.QTypeShort === "MMG") {
          mmgDeductionPoint = mmgDeductionPoint + 1;
          extraPoints =
            extraPoints +
            parseFloat(((100 - element.deductionPercentage) / 100).toFixed(2));
        } else {
          if (element.isCorrect !== 1) {
            let questionData = {
              number: element.number,
              question: element.questionText,
              questionGraphic: element.questionGraphicUrl,
              QTypeShort: element.QTypeShort,
            };
            if (element.QTypeShort === "MTR") {
              questionData.answers = [
                element.correctAnswersCount +
                  " of " +
                  element.expectedAnswersCount +
                  " Marked Correctly",
              ];
              questionData.expectedAnswersCount = element.expectedAnswersCount;
              questionData.correctAnswersCount = element.correctAnswersCount;
            } else {
              questionData.answers = [element.givenAnswerText];
            }
            incorrectQuestions.push(questionData);
          }
        }
      });
      let matTotalCorrect = 0;
      let totalCorrectQuestions =
        this.state.totalQuestions - incorrectQuestions.length;

        //---------------------------------------------------------------------------
        incorrectQuestions.forEach((questionItem) => {
        if (questionItem.QTypeShort === "MTR") {
          // Extra points for multiple true type question
          let correctAnswersPoints = Math.round(
            (questionItem.correctAnswersCount /
              questionItem.expectedAnswersCount) *
              100
          );
          if (correctAnswersPoints >= 50) {
            extraPoints = extraPoints + 0.5;
          }
        }
        // Extra points for matching type question
        if (questionItem.QTypeShort === "MAT") {
          if (this.state.isTest) {
            // extra points for test flow
            if (
              questionItem.correctAnswersCount ===
              questionItem.expectedAnswersCount
            ) {
              matTotalCorrect = matTotalCorrect + 1;
            } else {
              let correctAnswersPoints = Math.round(
                (questionItem.correctAnswersCount /
                  questionItem.expectedAnswersCount) *
                  100
              );
              if (correctAnswersPoints >= 50) {
                extraPoints = extraPoints + 0.5;
              }
            }
          } else {
            // extra points for quiz flow
            if (
              questionItem.correctAnswersCount ===
              questionItem.expectedAnswersCount
            ) {
              matTotalCorrect = matTotalCorrect + 1;
            }
            extraPoints =
              extraPoints +
              parseFloat(
                ((100 - questionItem.deductionPercentage) / 100).toFixed(2)
              );
          }
        } else if (questionItem.QTypeShort === "PIO") {
          if (this.state.isTest) {
            // extra points for test flow
            if (questionItem.isCorrect === 1) {
              matTotalCorrect = matTotalCorrect + 1;
            } else {
              let correctAnswersPoints = Math.round(
                (questionItem.correctAnswersCount /
                  questionItem.expectedAnswersCount) *
                  100
              );
              if (correctAnswersPoints >= 50) {
                extraPoints = extraPoints + 0.5;
              }
            }
          } else {
            // extra points for quiz flow
            if (questionItem.isCorrect === 1) {
              matTotalCorrect = matTotalCorrect + 1;
            }
            extraPoints =
              extraPoints +
              parseFloat(
                ((100 - questionItem.deductionPercentage) / 100).toFixed(2)
              );
          }
        } else if (questionItem.QTypeShort === "MIX") {
          // extra points for quiz flow
          if (questionItem.isCorrect === 1) {
            matTotalCorrect = matTotalCorrect + 1;
          }
          extraPoints =
            extraPoints +
            parseFloat(
              ((100 - questionItem.deductionPercentage) / 100).toFixed(2)
            );
        }
      });

      totalPoints = this.state.totalQuestions * this.state.perQuestionPoint;
      if (this.state.isTest) {
        correctPoints =
          (totalCorrectQuestions +
            matTotalCorrect +
            extraPoints -
            mmgDeductionPoint) *
          this.state.perQuestionPoint;
      } else {
        correctPoints =
          (totalCorrectQuestions + extraPoints - mmgDeductionPoint) *
          this.state.perQuestionPoint;
      }

      scorePercentage = Math.round((correctPoints / totalPoints) * 100);

      // Data to send on score report page
      const reportData = {
        incorrectQuestions: incorrectQuestions,
        totalCorrect: parseInt(totalCorrectQuestions + matTotalCorrect),
        totalQuestions: this.state.totalQuestions,
        quizTestTime: this.secondsToHms(this.state.currentSecondCount, 1),
        quizDifficulty: existingCookie.quiz_settings.diff,
        correctPoints: correctPoints,
        totalPoints: totalPoints,
        scorePercentage: scorePercentage,
      };

      this.props.saveReportScoreDetails(reportData);
      this.setState({
        isLoading: true,
      });

      if (this.state.isTest) {
        // TODO Remove name and email once we get userid working!!!
        let payload = {
          postkey: "qwerty5",
          userid: this.questionSetDetails.SessionUserID,
          username: this.questionSetDetails.SessionUserName,
          sessiontoken: this.questionSetDetails.SessionToken,
          // name: this.props.testUserDetails.name,
          // email: this.props.testUserDetails.email,
          // trackpass: this.props.testUserDetails.password,
          score: reportData.scorePercentage,
          source: "TEST",
          qsid: global.config.QSID,
        };

        this.props
          .postTestScore(payload)
          .then((res) => {
            this.props.history.push("/score-report", { isTest: "1" });
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        if (this.props.testUserDetails && this.props.testUserDetails.email) {
          let payload = {
            postkey: "qwerty5",
            name: this.props.testUserDetails.name,
            email: this.props.testUserDetails.email,
            trackpass: this.props.testUserDetails.password,
            score: reportData.scorePercentage,
            source: "QUIZ-" + quizSource[reportData.quizDifficulty],
            qsid: global.config.QSID,
          };
          this.props
            .postTestScore(payload)
            .then((res) => {
              this.props.history.push("/score-report");
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.props.history.push("/score-report");
        }
      }
    }
  };

  //---------------------------------------------------------------------------
  setMATOptionsCount = (connectedMATOptionsCount, totalMATOptionsCount) => {
    this.setState({
      connectedMATOptionsCount,
      totalMATOptionsCount,
    });
  };

  //---------------------------------------------------------------------------
  getQuestionTypeInfoText = (questionType) => {
    switch (questionType) {
      case "MCH":
        return "Select Best Answer";
      case "MTR":
        return "Check All That Are True";
      case "MAT":
        return (
          this.state.connectedMATOptionsCount +
          " of " +
          this.state.totalMATOptionsCount
        );
      default:
        return "";
    }
  };

  //---------------------------------------------------------------------------
  imageLoaded = () => {
    // Hide image loader
    this.setState({
      isImageLoading: false,
    });
  };

  //---------------------------------------------------------------------------
  getRandomAnswers = (list, itemsCount) => {
    return orderBy(sampleSize(list, itemsCount), "id", "ASC");
  };

  //---------------------------------------------------------------------------
  getRandomAnswersWithSingleCorrect = (list, itemsCount) => {
    let correctAnswersList = sampleSize(filter(list, { answerValue: "T" }), 1);

    let inCorrectAnswersList = sampleSize(
      filter(list, { answerValue: "F" }),
      itemsCount - 1
    );

    return orderBy(
      concat(correctAnswersList, inCorrectAnswersList),
      "id",
      "ASC"
    );
  };

  //---------------------------------------------------------------------------
  setQuizQuestion = (question) => {
    this.setState(
      {
        quizQuestion: question,
      },
      () => {
        this.resetHeaderPosition();
        this.setState({
          isLoading: false,
        });
      }
    );
  };

  //---------------------------------------------------------------------------
  setPuzzleStatus = (value) => {
    this.setState({
      isPuzzleSolvingStarted: value,
    });
  };

  //---------------------------------------------------------------------------
  // Main Render Function
  //---------------------------------------------------------------------------
  render() {
    const {
      isLoading,
      currentQuestionId,
      totalQuestions,
      currentQuestion,
      currentSecondCount,
      isImageLoading,
      quizQuestion,
    } = this.state;
    const { questionSetDetails } = this.props;
    this.resetHeaderPosition();

    return (
      <div className="question-details-container">
        {isLoading && !currentQuestion ? (
          <LoaderComponent loading={isLoading} />
        ) : (
          <React.Fragment>
            <div className="question-header-container" id="question_header">
              <div className="container-area">
                <div className="header-content">
                  <NavLink className="home-icon-container" to={"/"}>
                    <img src={homeIcon} alt="home" />
                  </NavLink>
                  <div className="quiz-details">
                    <div className="quiz-questions-count-container">
                      {currentQuestionId}/{totalQuestions}
                    </div>
                    <div className="quiz-time-container">
                      {this.secondsToHms(currentSecondCount)}
                    </div>
                  </div>
                  <div className="question-type-info-container">
                    {this.getQuestionTypeInfoText(currentQuestion.QTypeShort)}
                  </div>
                </div>
                <div className="question-text">
                  {quizQuestion ? quizQuestion : currentQuestion.QLong}
                </div>
              </div>
            </div>
            <div className={"question-data-container"}>
              {currentQuestion && (
                <div
                  className={
                    "question-details" +
                    (currentQuestion.QTypeShort === "MAT"
                      ? " mat-question-container"
                      : currentQuestion.QTypeShort === "MMG"
                      ? " mmg-question-details"
                      : "")
                  }
                >
                  {currentQuestion.QGraphicURL && (
                    <div className="question-graphic-container">
                      <div
                        style={{
                          display: isImageLoading ? "block" : "none",
                        }}
                      >
                        <ImageLoader />
                      </div>
                      <img
                        src={
                          questionSetDetails.QSResourcePath +
                          currentQuestion.QGraphicURL
                        }
                        alt="question-graphic"
                        onLoad={() => {
                          this.setState({ isImageLoading: false });
                        }}
                        style={{ display: isImageLoading ? "none" : "block" }}
                      />
                    </div>
                  )}
                  {currentQuestion.QTypeShort === "MCH" && (
                    <MCHTypeQuestion
                      currentQuestion={currentQuestion}
                      currentQuestionId={this.state.currentQuestionId}
                      addAttendedQuestion={this.addAttendedQuestion}
                      getRandomAnswersWithSingleCorrect={
                        this.getRandomAnswersWithSingleCorrect
                      }
                    />
                  )}
                  {currentQuestion.QTypeShort === "MTR" && (
                    <MTRTypeQuestion
                      currentQuestion={currentQuestion}
                      currentQuestionId={this.state.currentQuestionId}
                      addAttendedQuestion={this.addAttendedQuestion}
                      getRandomAnswers={this.getRandomAnswers}
                    />
                  )}
                  {currentQuestion.QTypeShort === "MAT" && (
                    <MATTypeQuestion
                      currentQuestion={currentQuestion}
                      isTest={this.state.isTest}
                      currentQuestionId={this.state.currentQuestionId}
                      addAttendedQuestion={this.addAttendedQuestion}
                      setMATOptionsCount={this.setMATOptionsCount}
                      questionSetDetails={questionSetDetails}
                      getRandomAnswers={this.getRandomAnswers}
                    />
                  )}
                  {currentQuestion.QTypeShort === "PIO" && (
                    <PIOTypeQuestion
                      currentQuestion={currentQuestion}
                      isTest={this.state.isTest}
                      currentQuestionId={this.state.currentQuestionId}
                      addAttendedQuestion={this.addAttendedQuestion}
                      getRandomAnswers={this.getRandomAnswers}
                    />
                  )}
                  {currentQuestion.QTypeShort === "MMG" && (
                    <MMGTypeQuestion
                      currentQuestion={currentQuestion}
                      isTest={this.state.isTest}
                      currentQuestionId={this.state.currentQuestionId}
                      addAttendedQuestion={this.addAttendedQuestion}
                      questionSetDetails={questionSetDetails}
                      getRandomAnswers={this.getRandomAnswers}
                    />
                  )}
                  {currentQuestion.QTypeShort === "MIX" && (
                    <MIXTypeQuestion
                      currentQuestion={currentQuestion}
                      isTest={this.state.isTest}
                      currentQuestionId={this.state.currentQuestionId}
                      addAttendedQuestion={this.addAttendedQuestion}
                      getRandomAnswers={this.getRandomAnswers}
                      setQuizQuestion={this.setQuizQuestion}
                      setPuzzleStatus={this.setPuzzleStatus}
                    />
                  )}
                </div>
              )}
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

//-----------------------------------------------------------------------------
const mapStateToProps = (state) => {
  return {
    fastQuizQuestions: state.fastQuizQuestions,
    testUserDetails: state.testUserDetails,
    questionSetDetails: state.questionSetDetails,
  };
};

//-----------------------------------------------------------------------------
export default connect(mapStateToProps, {
  getFastQuizQuestions,
  saveReportScoreDetails,
  postTestScore,
})(QuizPage);
